import React from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "../../../../../redux/store";
import { getActionPerVisitor, getInteractionWithTheAcc, getOpenedTheAccessibility } from "../../../../../selectors";
import VisitorsAccessibilityWidget from "../widgets/VisitorsThatOpenedTheWidget";
import ActionsPerVisitorOnTheWidget from "../widgets/ActionsPerVisitorOnTheWidget";
import VisitorsInteractionWithTheWidget from "../widgets/VisitorsInteractionWithTheWidget";

const ServiceMetrics = () => {
  const openedTheAccessibility = useSelector<any>(getOpenedTheAccessibility)
  const interactionWithTheAcc = useSelector<any>(getInteractionWithTheAcc)
  const actionPerVisitor = useSelector<any>(getActionPerVisitor)

  return (
    <>
      <Grid item xs={12} sm={12} md={6}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <VisitorsAccessibilityWidget data={openedTheAccessibility} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <ActionsPerVisitorOnTheWidget data={actionPerVisitor} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <VisitorsInteractionWithTheWidget data={interactionWithTheAcc} />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default ServiceMetrics
